import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IResponse } from './response.model';
import { TemplateApiService } from './template-api.service';

export interface IEmailEnviado extends IResponse {
    ultimo_envio: string;
    tipo: string;
    destinatario: string;
    erro: string | null;
}

@Injectable()
export class AdminEmailsService extends TemplateApiService<IEmailEnviado> {

    public override setBaseUrl(): void {
        this.baseUrl = 'admin/emails';
    }

    reenviar(uuid: string): Observable<IEmailEnviado> {
        return this.update(uuid, { reenvio: true });
    }
}
